import { createRoot } from "react-dom/client";
import { CssBaseline } from "@mui/material";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store";
import "react-datepicker/dist/react-datepicker.css";

const container = document.querySelector("#root")!;
const root = createRoot(container);
const startPage = "/";
if (window.location.pathname !== startPage) {
  window.location.href = "/";
}
root.render(
  <Provider store={store}>
    <CssBaseline />
    <App />
  </Provider>,
);
